import React from 'react';
import PropTypes from 'prop-types';
import JsonapiClient from '@holidayextras/jsonapi-client';
import axios from 'axios';
import _ from 'lodash';
import validator from 'validator';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Image, Card, Dropdown, Grid, Icon, Button, Segment, Popup, Divider } from 'semantic-ui-react';
import hasUserInfo from '../../hocs/has-user-info';
import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';
import { checkUserIsTeamMember } from '../../utils/role-service';
import { getTrackedAssetAnalytics } from '../../utils/tracked-assets-analytics-service';
import BudgetReadonly from '../../components/budget-readonly';
import ACRDemographicsWrapper from '../acr-demographics-wrapper';
import SocialTable from '../../components/social-table';
import AddAssetForm from '../../components/add-asset-form';
import AssetTable from '../../components/asset-table';
import InviteModal from '../../components/invite-modal';
import AddStoryModal from '../../components/add-story-modal';
import InfluencerFeeModal from '../../components/influencer-fee-modal';
import sendLimitsExceededNotification from '../../utils/send-limits-exceeded-notifcation';
import ShopifyTable from '../../components/shopify-table';
import ShopifyConfig from '../../components/shopify-config';
import { getShopifyOrdersByDiscussionId } from '../../hocs/has-shopify';

const INVITATION_STATUS = {
  deferred: 'DEFERRED',
  sent: 'SENT',
  accepted: 'ACCEPTED',
};

const ASSET_API_TIMEOUT = 2500;

const dropdownStyle = {
  marginBottom: 1,
};

const INFLUENCER_LIMIT = 200;
const SHOW_SHOPIFY = true;

const InvitationSentComponent = ({ influencer }) => (
  <div>
    <Icon name="warning" color="orange" />
    &nbsp;{influencer.name} has been invited, but has not accepted yet.
  </div>
);

const NoEmailComponent = ({ influencer }) => (
  <div>
    <Icon name="warning" color="orange" />
    &nbsp;No email address for {influencer.name}. Please update in My Influencers.
  </div>
);

const InvitationDeferredComponent = ({ influencer }) => (
  <div>
    <Icon name="info" color="green" />
    &nbsp;{influencer.name} has not been invited yet. Use the pink button to send an invitation.
  </div>
);

const InvitationJoinedComponent = ({ influencer }) => (
  <div>
    <Icon name="handshake outline" color="blue" />
    &nbsp;{influencer.name} has joined the campaign.
  </div>
);

class CollaborationCard extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      loading: true,
      deleting: false,
      sendingInvite: false,
      feeModalOpen: false,
      inviteSentOK: false,
      modalInvitation: null,
      invitationSent: false,
      status: 'initial',
      className: 'removable-initial',
      addStoryVisible: false,
      assetsDetails: [],
      asset: {
        adding: false,
        platform: null,
        url: null,
        errors: {
          url: false,
        },
      },
      shopifyLoading: true,
      shopifyOrders: [],
    };

    this.jsonClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    this.restClient = axios.create({
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  loadShopify = async discussionId => {
    this.setState({ shopifyLoading: true });
    const { orders } = await getShopifyOrdersByDiscussionId({ discussionId });
    this.setState({ shopifyLoading: false, shopifyOrders: orders });
    console.log('shopifyOrders', orders);
  };

  componentDidMount() {
    const discussion = this.props.discussion.toJSON();
    const discussionId = this.props.discussion.get('id');
    const channelURL = this.props.discussion.get('channelURL');
    const userId = this.props.userData.get('id');

    this.loadShopify(discussionId);

    const trackedAssets = this.props.discussion.get('trackedAssets');

    const trackedAssetsArray = trackedAssets.toJS();

    const nonAnalyticsPlatforms = ['TIKTOK', 'SNAPCHAT', 'VK', 'BLOG'];

    const trackedAssetsForAnalytics = _.reject(trackedAssetsArray, asset => _.includes(nonAnalyticsPlatforms, asset.platform) || asset.fetchStatus === 'NOT_FOUND');
    const trackedAssetsWithoutAnalytics = _.filter(trackedAssetsArray, asset => _.includes(nonAnalyticsPlatforms, asset.platform));

    console.log(trackedAssetsWithoutAnalytics);

    // TODO need to pass in the real asset list here as well.
    // The embedded trackedAsset cannot be trusted!!
    const collabAssets = _.compact(_.concat(trackedAssetsForAnalytics));
    if (collabAssets && collabAssets.length) {
      getTrackedAssetAnalytics(collabAssets)
        .then(response => {
          const assetsDetails = _.map(response, row => {
            const data = row.response.data;
            if (!data || !data.trackedAsset) {
              return {
                trackedAsset: row,
                withError: true,
              };
            }
            data.trackedAsset = _.find(collabAssets, { assetId: data.trackedAsset.assetId });
            return data;
          });
          return this.setState({
            assetsDetails: _.concat(trackedAssetsWithoutAnalytics, assetsDetails),
            loading: false,
          });
        })
        .catch(e => reportError('TRACKED_ASSET_ANALYTICS', e));
    } else {
      return this.setState({
        loading: false,
      });
    }
  }

  onNewFeeSubmit = fee => {
    const discussionId = this.props.discussion.get('id');
    this.jsonClient.get('discussions', discussionId, {}, (err, resource) => {
      resource.set('budget', fee);
      resource.set('budgetStatus', 'APPROVED');
      resource.sync().then(() => {
        this.setState({
          feeModalOpen: false,
        }, this.props.refreshPageHandler);
      });
    });
  }

  loadAsset = asset => {
    getTrackedAssetAnalytics([asset])
      .then(response => {
        const newAssetDetails = _.map(response, 'response.data')[0];
        console.log(newAssetDetails);
        if (newAssetDetails) {
          newAssetDetails.trackedAsset = asset; // set the tracked asset to this one associated with the campaign
          const { assetsDetails } = this.state;
          assetsDetails.pop(); // get rid of the last entry (fetching place holder)
          const placeHolder = {
            trackedAsset: {
              id: response[0].id,
            },
            withError: true,
          };
          assetsDetails.push(newAssetDetails || placeHolder);
          return this.setState({
            assetsDetails,
          });
        }
      });
  }

  toggleAddStoryModal = () => {
    console.log('[showAddStoryModal]');
    const { addStoryVisible } = this.state;
    this.setState({ addStoryVisible: !addStoryVisible });
  }

  addStory = asset => {
    const { assetsDetails } = this.state;
    assetsDetails.push({
      text: 'fetching data...',
      state: 'FETCHING',
      trackedAsset: asset,
    });

    this.setState({
      assetsDetails,
    });

    setTimeout(() => {
      this.loadAsset(asset);
    }, ASSET_API_TIMEOUT);
  }

  viewDiscussion = discussion => () => {
    this.context.router.push(`/campaign/discussion/${discussion.get('id')}`);
  };

  deleteDiscussionRelationship = discussionId => {
    const {
      campaign,
    } = this.props;
    const campaignId = campaign.get('id');

    const token = authService.getToken();

    const ax = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 1000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const campaignUrl = `/campaigns/${campaignId}`;
    return ax.get(campaignUrl)
      .then(r => {
        const { relationships } = r.data.data;
        return relationships.discussions.data;
      })
      .then(discussions => {
        const newDiscussions = _.reject(discussions, { id: discussionId });
        return { data: { attributes: { discussions: newDiscussions } } };
      })
      .then(payload => ax.patch(campaignUrl, payload));
  }

  removeCollaboration = (discussionId, invitationId) => {
    console.log(`d: ${discussionId}`);
    console.log(`i: ${invitationId}`);

    const collaborationDeleteUrl = `/discussions/${discussionId}`;
    const invitationDeleteUrl = `/campaignInvitation/${invitationId}`;

    const token = authService.getToken();

    const ax = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 1000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return ax.delete(collaborationDeleteUrl)
      .then(() => this.deleteDiscussionRelationship(discussionId))
      .then(() => {
        if (invitationId) {
          console.log(`deleting invitation ${invitationId}`);
          return ax.delete(invitationDeleteUrl);
        }
        return Promise.resolve();
      })
      .then(() => this.remove());
  };

  remove() {
    this.setState({
      className: 'removable-removing',
    });

    setTimeout(() => {
      this.setState({ className: 'removable-removed' });
    }, 1500);
  }

  toggleAddAssetPopup = (e, data) => {
    const { asset, hasCheckedLimitNotification } = this.state;
    asset.adding = !asset.adding;
    asset.platform = _.isUndefined(data) ? null : data.value;
    if (!hasCheckedLimitNotification) {
      this.checkLimitsNotification();
    }
    this.setState({
      asset,
      hasCheckedLimitNotification: true,
    });
  };

  checkLimitsNotification = () => {
    const { restClient, trackedAssetsCount, userInfo: { organisationId, name, userId }, organisation } = this.props;
    if (!trackedAssetsCount || !organisation) return;
    if (trackedAssetsCount < organisation.licenseTrackedAssetLimit) return;
    sendLimitsExceededNotification(restClient, {
      data: {
        name: `${name} `,
        organisationId,
        userId,
        organisationName: `${organisation.name} `,
        assetType: 'tracked assets',
        licenseSubscriptionType: organisation.licenseSubscriptionType,
        url: window.location.href,
      },
    });
  }

  assetFormSubmitHandler = details => {
    const {
      discussion,
      campaign,
      refreshPageHandler,
      userInfo: {
        organisationId,
      },
    } = this.props;
    const { asset } = this.state;


    const discussionId = discussion.get('id');
    const discussionName = discussion.get('name');
    const campaignName = campaign.get('name');

    if (details) {
      const trackedAsset = this.jsonClient.create('trackedAssets');
      trackedAsset.set('assetId', details.assetId);
      trackedAsset.set('assetURL', details.assetURL);
      trackedAsset.set('user', {
        type: 'users',
        id: authService.uid(),
      });
      trackedAsset.set('campaign', {
        type: 'campaigns',
        id: campaign.get('id'),
      });
      trackedAsset.set('discussion', {
        type: 'discussions',
        id: discussionId,
      });
      trackedAsset.set('organisation', {
        type: 'organisations',
        id: organisationId,
      });
      trackedAsset.set('discussionName', discussionName);
      trackedAsset.set('campaignName', campaignName);
      trackedAsset.set('platform', details.platform);
      trackedAsset.set('assetType', details.assetType);
      trackedAsset.set('createdSource', 'CAMPAIGN');
      trackedAsset.sync()
        .then(response => {
          const newTrackedAsset = response.toJSON();
          return {
            data: {
              type: 'trackedAssets',
              id: newTrackedAsset.id,
            },
          };
        })
        .then(payload => {
          const mainUrl = `${process.env.REACT_APP_API_BASE_URL}`;
          const relUrl = `${mainUrl}/discussions/${discussionId}/relationships/trackedAssets`;
          return this.restClient.post(relUrl, payload);
        })
        .then(() => {
          asset.adding = false;
          asset.platform = null;
          const { assetsDetails } = this.state;
          assetsDetails.push({
            text: 'fetching data...',
            state: 'FETCHING',
            trackedAsset: trackedAsset.toJSON(),
          });
          return this.setState({
            assetsDetails,
          });
        })
        .then(() => {
          setTimeout(() => {
            this.loadAsset(trackedAsset.toJSON());
          }, ASSET_API_TIMEOUT);
          return { finished: true };
        })
        .catch(err => {
          console.log(err);
          asset.errors.url = true;
        });
    }
  }

  patchDiscussionTrackedAssets = (patch, removedId) => {
    const discussionId = this.props.discussion.get('id');
    const mainUrl = `${process.env.REACT_APP_API_BASE_URL}`;
    const relUrl = `${mainUrl}/discussions/${discussionId}/relationships/trackedAssets`;
    this.restClient.patch(relUrl, { data: patch }).then(() => {
      const { assetsDetails } = this.state;
      const updated = _.filter(assetsDetails, row => row.trackedAsset.id !== removedId);
      this.setState({
        assetsDetails: updated,
        loading: false,
        deleting: false,
      });
    }).catch(() => {
      this.setState({
        deleting: false, loading: false,
      });
    });
  }

  removeAsset = (event, { value }) => {
    const id = value.trackedAsset.id;

    const { assetsDetails } = this.state;

    this.setState({
      deleting: true,
      loading: true,
    });

    if (assetsDetails) {
      const updated = _.reject(assetsDetails, ['trackedAsset.id', id]);
      const patch = _.map(updated, row => ({
        id: row.trackedAsset.id,
        type: 'trackedAssets',
      }));
      this.jsonClient.get('trackedAssets', id, (err, asset) => {
        this.patchDiscussionTrackedAssets(patch, id);
        if (asset && !err) {
          asset.delete(error => {
            if (error) {
              console.error(error);
            }
          });
        }
      });
    }
  }

  toggleSendInviteModal = () => {
    const { sendingInvite } = this.state;
    const { campaign, influencer } = this.props;
    const { id } = campaign.toJSON();

    const query = `?filter[campaign]=${id}&page[limit]=${INFLUENCER_LIMIT}`;
    const url = `${process.env.REACT_APP_API_BASE_URL}/campaignInvitation${query}`;

    return this.restClient.get(url)
      .then(response => response.data.data)
      .then(invitations => {
        const modalInvitation = _.find(invitations, [
          'attributes.metadata.influencerId',
          influencer.id,
        ]);
        if (modalInvitation) {
          return this.setState({
            modalInvitation,
            sendingInvite: true,
            sendingError: false,
            invitationSent: true,
          });
        }
        return Promise.reject('could not find invitation');
      });
  }

  closeInviteModal = () => {
    this.setState({
      modalInvitation: null,
      sendingInvite: false,
      sendingError: false,
      inviteSentOK: false,
    });
  }

  getUserIdFromInvitation = invitation => {
    const { user } = invitation.relationships;
    return user && user.data ? user.data.id : null;
  }

  sendInviteToInfluencer = () => {
    const { modalInvitation } = this.state;
    const { influencer } = this.props;
    const userId = this.getUserIdFromInvitation(modalInvitation);

    if (userId) {
      this.patchUser({ influencer, userId })
        .then(() => {
          this.patchCampaignInvitation({ modalInvitation, influencer });
        });
    } else {
      this.patchCampaignInvitation({ modalInvitation, influencer });
    }
  }

  patchUser = params => {
    const { influencer, userId } = params;
    const patch = {
      data: {
        type: 'users',
        id: userId,
        attributes: {
          email: influencer.email,
        },
      },
    };
    const url = `${process.env.REACT_APP_API_BASE_URL}/users/${userId}`;
    return this.restClient.patch(url, patch);
  }

  patchCampaignInvitation = params => {
    const { modalInvitation, influencer } = params;
    const { userInfo: { name }, organisation } = this.props;

    const patch = {
      data: {
        type: 'campaignInvitation',
        id: modalInvitation.id,
        attributes: {
          status: 'SENT',
          email: influencer.email,
          sentBy: name,
          sentDate: new Date(),
          organisationName: organisation.name,
        },
      },
    };
    const url = `${process.env.REACT_APP_API_BASE_URL}/campaignInvitation/${modalInvitation.id}`;
    return this.restClient.patch(url, patch).then(() => this.setState({
      sendingError: false,
      modalInvitation: null,
      inviteSentOK: true,
    })).catch(error => this.setState({
      updatingInvitationStatusError: error,
      sendingInvite: false,
      sendingError: false,
      inviteSentOK: false,
      modalInvitation: null,
    }));
  }

  toggleFeeModalState = () => {
    this.setState(prevState => ({
      feeModalOpen: !prevState.feeModalOpen,
    }));
  }

  render() {
    const {
      discussion,
      myUserRole,
      influencer,
      campaign,
      currency,
      organisation,
      trackedAssetsCount,
      router,
      userInfo,
    } = this.props;

    const stories = _.compact(discussion.get('stories').toJSON());
    const { isUserSuperAdmin } = userInfo;


    const {
      asset,
      assetsDetails,
      loading,
      sendingInvite,
      inviteSentOK,
      invitationSent,
      addStoryVisible,
      feeModalOpen,
      shopifyLoading,
      shopifyOrders,
    } = this.state;

    const DIVIDER = 'divider';
    const REPORTING = 'REPORTING';

    console.log('discussion', discussion.toJSON());

    const invite = discussion.get('invitations').toJS()[0];
    const discussionId = discussion.get('id');
    const shopifyDiscountCode = discussion.get('discountCode');
    const shopifyCommission = discussion.get('commission');
    const invitationId = invite ? invite.id : null;
    const campaignId = campaign.get('id');
    const campaignName = campaign.get('name');
    const campaignType = campaign.get('campaignType');
    const hasShopifyData = !!shopifyDiscountCode;
    const discussionName = discussion.get('name');

    const isACR = campaignType === 'ACR';

    const allDropdownOptions = [
      {
        label: 'add facebook post',
        icon: 'facebook',
        value: 'facebook',
        color: 'red',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add twitter post',
        icon: 'twitter',
        value: 'twitter',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add instagram post',
        icon: 'instagram',
        value: 'instagram',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add youtube video',
        icon: 'youtube',
        value: 'youtube',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add story',
        icon: 'circle outline',
        value: 'story',
        onClick: this.toggleAddStoryModal,
        show: !isACR,
      },
      {
        type: DIVIDER,
        show: !isACR,
      },
      {
        label: 'set influencer fee',
        icon: 'dollar',
        value: 'fee',
        onClick: this.toggleFeeModalState,
        show: !isACR,
      },
      {
        type: DIVIDER,
        show: !isACR,
      },
      {
        label: 'send invite',
        icon: 'mail outline',
        value: influencer.id,
        onClick: this.toggleSendInviteModal,
        disabled: !_.isString(influencer.email),
        popupText: `${influencer.name} does not have an email address.
        Update the influencer in My Influencers and try again.`,
        show: true,
      },
      {
        label: 'remove collaboration',
        icon: 'remove circle outline',
        onClick: () => this.removeCollaboration(discussionId, invitationId),
        show: true,
      },
    ];

    const dropdownOptions = _.filter(allDropdownOptions, 'show');

    const cardStyles = {
      width: '98%',
      margin: '20px auto',
    };

    const cardContent = {
      paddingBottom: 11,
    };

    const noPadding = {
      padding: 0,
      marginBottom: 0,
      border: 0,
    };

    const thumbnailStyles = {
      height: '50px',
      width: '50px',
    };

    const textStyles = {
      color: '#000',
    };

    // eslint-disable-next-line max-len
    const currentBrief = discussion.get('currentBrief') ? discussion.getIn(['documents', discussion.get('currentBrief')]) : null;
    // eslint-disable-next-line max-len
    const currentContract = discussion.get('currentContract') ? discussion.getIn(['documents', discussion.get('currentContract')]) : null;
    // eslint-disable-next-line max-len
    const signedContract = discussion.get('signedContract') ? discussion.getIn(['documents', discussion.get('signedContract')]) : null;

    const deliverable = discussion.get('deliverables') || null;
    const budget = discussion.get('budget');
    const budgetStatus = discussion.get('budgetStatus');
    const discussionType = discussion.get('discussionType');

    const isUserTeamMember = isUserSuperAdmin || checkUserIsTeamMember(myUserRole);
    const unreadMessageCount = discussion.get('unreadMessageCount');
    const influencerJoined = (invite === undefined);
    const derivedSent = invite ? ((invite.status === INVITATION_STATUS.sent) || invitationSent) : false;

    const isEmailValid = validator.isEmail(influencer.email || '');

    const getContent = (emailAddress, isEmailValid) => {
      if (isEmailValid) return `${influencer.email} is a valid email.`;
      return emailAddress ? `${influencer.email} is not a valid email.` : 'no email address in database';
    };

    const getCardExtra = joined => {
      if (!influencer.email) {
        return (
          <p className="small">
            {
              <NoEmailComponent influencer={influencer} />
            }
          </p>
        );
      }
      if (joined) {
        return (
          <p className="small">
            {
              <InvitationJoinedComponent influencer={influencer} />
            }
          </p>
        );
      }

      return (
        <p className="small">
          {
            derivedSent
              ? <InvitationSentComponent influencer={influencer} />
              : <InvitationDeferredComponent influencer={influencer} />
          }
        </p>
      );
    };

    const isOverLimit = !organisation || trackedAssetsCount >= organisation.licenseTrackedAssetLimit;

    return (
      <div className={this.state.className}>
        <Card
          fluid
          style={cardStyles}
          color={discussionType === REPORTING ? 'pink' : 'grey'}
        >
          <Card.Content style={cardContent} verticalAlign="middle">
            <Grid padded="horizontally">
              <Grid.Row verticalAlign="middle">
                <Grid.Column width={isACR ? 6 : 4} style={noPadding}>
                  <div style={textStyles}>
                    <Image
                      src={influencer.thumbnail}
                      style={thumbnailStyles}
                      floated="left" size="tiny" shape="circular"
                    />
                    <h3>
                      {influencer.name}
                        &nbsp;
                      <Popup
                        trigger={<Icon name="mail" color={isEmailValid ? 'grey' : 'red'} />}
                        content={getContent(influencer.email, isEmailValid)}
                      />
                      &nbsp;
                      <Popup
                        trigger={<Icon name="briefcase" color={influencer.instagramBusinessAccount ? 'pink' : 'grey'} />}
                        content={`${influencer.instagramBusinessAccount ? '' : 'NOT an '}Instagram Business Account`}
                      />
                    </h3>
                    <p className="small light">
                      {discussion.get('name')}
                    </p>
                  </div>
                </Grid.Column>
                <Grid.Column width={1}>
                  { unreadMessageCount > 0 &&
                    <div className="unread-message">
                      <img src="/icons/unread.svg" alt="Unread messages" />
                      <p className="small">{unreadMessageCount}</p>
                    </div>
                  }
                </Grid.Column>
                <Grid.Column width={isACR ? 8 : 6} style={noPadding}>
                  <SocialTable influencer={influencer} />
                </Grid.Column>
                {!isACR &&
                  <Grid.Column width={4} style={noPadding} textAlign="right">
                    <div>
                      <span>Fee:&nbsp;</span>
                      <BudgetReadonly
                        currency={currency}
                        budget={budget}
                        budgetStatus={budgetStatus}
                        mode=""
                      />
                    </div>
                  </Grid.Column>
                }
                <Grid.Column width={1} style={noPadding} verticalAlign="top" textAlign="right">
                  {
                    isUserTeamMember &&
                      <Dropdown
                        icon={null}
                        pointing="top right"
                        floating
                        style={dropdownStyle}
                        trigger={<Button icon="bars" color="pink" />}
                      >
                        <Dropdown.Menu>
                          {
                            _.map(dropdownOptions, opt => {
                              if (opt.type === DIVIDER) {
                                return (<Dropdown.Divider />);
                              }

                              if (opt.disabled && opt.popupText) {
                                return (
                                  <Popup
                                    trigger={
                                      <Dropdown.Item
                                        onClick={_.noop()}
                                        value={opt.value}
                                      >
                                        <Icon name={opt.icon} />{opt.label}
                                      </Dropdown.Item>
                                    }
                                    content={opt.popupText}
                                  />
                                );
                              }

                              return (
                                <Dropdown.Item
                                  disabled={opt.disabled}
                                  onClick={opt.onClick}
                                  value={opt.value}
                                >
                                  <Icon name={opt.icon} />{opt.label}
                                </Dropdown.Item>
                              );
                            })
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>

          </Card.Content>
          {
            ((assetsDetails && assetsDetails.length > 0) || (stories && stories.length > 0)) &&
            !isACR &&
            <Card.Content extra style={noPadding}>
              <Segment basic loading={loading} style={{ padding: 10 }}>
                <AssetTable
                  campaignName={campaignName}
                  stories={stories}
                  influencer={influencer}
                  assets={assetsDetails}
                  deleteAssetHandler={this.removeAsset}
                  campaignType={campaignType}
                />
              </Segment>
            </Card.Content>
          }

          {
            isACR &&
            <ACRDemographicsWrapper
              campaign={campaign.toJSON()}
              influencer={influencer}
              userInfo={userInfo}
            />
          }

          <Card.Content extra textAlign="center">
            { getCardExtra(influencerJoined) }
          </Card.Content>
        </Card>

        {/* <h2>{discussionId} - {hasShopifyData ? 'yes' : 'no'} - {shopifyDiscountCode} - {shopifyCommission}</h2> */}

        { hasShopifyData && shopifyDiscountCode && SHOW_SHOPIFY &&
        <Card
          fluid
          style={cardStyles}
        >
          <ShopifyConfig
            discountCode={shopifyDiscountCode}
            commission={shopifyCommission}
            editable={false}
          />
        </Card>
        }

        { !shopifyLoading && hasShopifyData && SHOW_SHOPIFY &&
          <Card
            fluid
            style={cardStyles}
          >
            <Card.Content>
              <Grid columns="2">
                <Grid.Row>
                  <Grid.Column verticalAlign="middle">
                    <h3><img
                      src="/icons/shopify.svg"
                      alt="Shopify"
                    /> Shopify Total Sales
                    </h3>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
            <Card.Content>
              <Card.Content>
                <p>
                  Data will appear in the table below, once the Shopify code or URL have been used by one of your customers.
                </p>
                <Divider />
              </Card.Content>
              <ShopifyTable
                orders={shopifyOrders}
              />
            </Card.Content>
          </Card>
        }

        {
          asset.adding &&
          <AddAssetForm
            isOverLimit={isOverLimit}
            isOpen={asset.adding}
            platform={asset.platform}
            errors={asset.errors}
            popupToggleHandler={this.toggleAddAssetPopup}
            addAssetHandler={this.assetFormSubmitHandler}
          />
        }

        {
          sendingInvite &&
          <InviteModal
            thumbnail={influencer.thumbnail}
            closeHandler={this.closeInviteModal}
            sendHandler={this.sendInviteToInfluencer}
            email={influencer.email}
            inviteSentOK={inviteSentOK}
          />
        }

        {
          feeModalOpen &&
          <InfluencerFeeModal
            influencer={influencer}
            currency={currency}
            budget={budget}
            onClose={this.toggleFeeModalState}
            onSubmit={this.onNewFeeSubmit}
          />
        }

        {
          addStoryVisible &&
          <AddStoryModal
            popupToggleHandler={this.toggleAddStoryModal}
            successHandler={this.addStory}
            campaignId={campaignId}
            discussionId={discussionId}
            discussionName={discussionName}
          />
        }


      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  members: state.members.get('members'),
  userData: state.userData.get('userData'),
  myUserRole: state.campaign.get('myUserRole'),
});

export function mapDispatchToProps(dispatch) {
  return {
    // onSetUnreadMessageCount: (discussionId, unreadMessageCount) =>
    //   dispatch(setUnreadMessageCount(discussionId, unreadMessageCount)),
    dispatch,
  };
}

CollaborationCard.propTypes = {
  discussion: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  trackedAssetsCount: PropTypes.number.isRequired,
  myUserRole: PropTypes.string.isRequired,
  influencer: PropTypes.object.isRequired,
  restClient: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
};


export default compose(
  hasUserInfo,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(CollaborationCard);



/** WEBPACK FOOTER **
 ** ./src/containers/collaboration-card/index.js
 **/